var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSldb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-SLDB"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SLDB",
    clipPath: "url(#clip-SLDB)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    transform: "translate(11 159)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 492,
    height: 141,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 491,
    height: 140,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    transform: "translate(16 167)",
    fill: "#bbb1b1",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 481,
    height: 125,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 480,
    height: 124,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    transform: "translate(16 195)",
    fill: "#440404",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 481,
    height: 97,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 480,
    height: 96,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "TRAIN_NO.",
    "data-name": "TRAIN NO.",
    transform: "translate(23 172)",
    fill: "#1c89f6",
    fontSize: 14,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "TRAIN NO.")), /*#__PURE__*/React.createElement("text", {
    id: "TRAIN_NAME",
    "data-name": "TRAIN NAME",
    transform: "translate(175 172)",
    fill: "#1c89f6",
    fontSize: 14,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "TRAIN NAME")), /*#__PURE__*/React.createElement("text", {
    id: "EXPT._TIME_A_D_PF_NO.",
    "data-name": "EXPT. TIME A/D PF NO.",
    transform: "translate(341 172)",
    fill: "#1c89f6",
    fontSize: 14,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "EXPT. TIME A/D PF NO.")), /*#__PURE__*/React.createElement("text", {
    id: "_12137_PANJAB_MAIL_ARRIVED_02",
    "data-name": "12137                        PANJAB MAIL                      ARRIVED     02",
    transform: "translate(23 197)",
    fill: "#f9cb11",
    stroke: "#f80b0b",
    strokeWidth: 1,
    fontSize: 16,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17,
    xmlSpace: "preserve"
  }, "12137                        PANJAB MAIL                      ARRIVED     02")), /*#__PURE__*/React.createElement("text", {
    id: "SLR_GS_GSHA1_AB1_A1_B1_B2_B3_B4_B5_S1_PC_S2_S3_S4_S5_S6_S7_S8_S9S10_MLTRMS",
    "data-name": "SLR  GS   GSHA1  AB1  A1  B1  B2   B3   B4   B5  S1 PC    S2    S3  S4    S5   S6   S7   S8  S9S10 MLTRMS",
    transform: "translate(23 223)",
    fill: "#f9cb11",
    stroke: "#fb0404",
    strokeWidth: 1,
    fontSize: 20,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 22,
    xmlSpace: "preserve"
  }, "SLR  GS   GSHA1  AB1  A1  B1  B2   B3   B4   B5  S1"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 49,
    xmlSpace: "preserve"
  }, "PC    S2    S3  S4    S5   S6   S7   S8  S9S10 MLTRMS")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSldb);
export default __webpack_public_path__ + "static/media/SLDB.b6efffb017abfab9a4ed256141a7bcd1.svg";
export { ForwardRef as ReactComponent };